import React, { useState } from "react";
import "../styles/ContactPage.css";
import { FaEnvelope, FaFacebook, FaInstagram, FaTwitter } from "react-icons/fa";
import { db, collection, addDoc } from "../firebase";
import FaqSection from "./parts/FaqSection";

const ContactPage = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        companySize: "",
        projectBudget: "",
        automationType: "",
        companyWebsite: "",
        description: "",
    });

    const [errors, setErrors] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [showPopup, setShowPopup] = useState(null);
    const [isLoading, setIsLoading] = useState(false); // Add loading state

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const validate = () => {
        let formErrors = {};
        if (!formData.name) formErrors.name = "Name is required.";
        if (!formData.email) formErrors.email = "Email is required.";
        if (!formData.email.match(/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/))
            formErrors.email = "Invalid email format.";
        return formErrors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const validationErrors = validate();
        if (Object.keys(validationErrors).length === 0) {
            setIsLoading(true); // Start loading
            try {
                await addDoc(collection(db, "contactForms"), formData);
                setIsSubmitted(true);
                setShowPopup("success");
                setFormData({
                    name: "",
                    email: "",
                    phone: "",
                    companySize: "",
                    projectBudget: "",
                    automationType: "",
                    companyWebsite: "",
                    description: "",
                });
            } catch (error) {
                console.error("Error submitting form: ", error);
                setShowPopup("error");
            } finally {
                setIsLoading(false); // Stop loading regardless of outcome
            }
        } else {
            setErrors(validationErrors);
        }
    };

    return (
        <div className="contact-page">
            <h1 className="contact-title">Request a Quote or Call</h1>
            <p className="contact-description">
                Interested in our services? Get in touch with us for a custom automation solution. Fill out the form below or contact us directly.
            </p>

            <form className="contact-form" onSubmit={handleSubmit}>
                {/* Form fields remain the same */}
                <div className="form-row">
                    <div className="form-group">
                        <label>Name</label>
                        <input
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            className="form-input"
                            required
                        />
                        {errors.name && <span className="error">{errors.name}</span>}
                    </div>

                    <div className="form-group">
                        <label>Email</label>
                        <input
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            className="form-input"
                            required
                        />
                        {errors.email && <span className="error">{errors.email}</span>}
                    </div>
                </div>

                {/* Rest of the form fields */}
                <div className="form-row">
                    {/* ... */}
                    <div className="form-group">
                        <label>Phone Number</label>
                        <input
                            type="text"
                            name="phone"
                            value={formData.phone}
                            onChange={handleChange}
                            className="form-input"
                        />
                    </div>

                    <div className="form-group">
                        <label>Company Size</label>
                        <select
                            name="companySize"
                            value={formData.companySize}
                            onChange={handleChange}
                            className="form-input"
                        >
                            <option value="">Select Size</option>
                            <option value="1-5">1-5 employees</option>
                            <option value="6-10">6-10 employees</option>
                            <option value="11-25">11-25 employees</option>
                            <option value="26-50">26-50 employees</option>
                            <option value="51-100">51-100 employees</option>
                            <option value="101-200">101-200 employees</option>
                            <option value="201-500">201-500 employees</option>
                            <option value="501-1000">501-1000 employees</option>
                            <option value="1000+">1000+ employees</option>
                        </select>
                    </div>
                </div>

                <div className="form-row">
                    <div className="form-group">
                        <label>Project Budget</label>
                        <select
                            name="projectBudget"
                            value={formData.projectBudget}
                            onChange={handleChange}
                            className="form-input"
                        >
                            <option value="">Select Budget</option>
                            <option value="Under1k">Under $1,000</option>
                            <option value="1k-5k">$1,000 - $5,000</option>
                            <option value="5k-10k">$5,000 - $10,000</option>
                            <option value="10k-20k">$10,000 - $20,000</option>
                            <option value="20k-50k">$20,000 - $50,000</option>
                            <option value="50k-100k">$50,000 - $100,000</option>
                            <option value="100k+">Over $100,000</option>
                            <option value="Custom">Custom Budget</option>
                        </select>
                    </div>

                    <div className="form-group">
                        <label>Type of Automation</label>
                        <select
                            name="automationType"
                            value={formData.automationType}
                            onChange={handleChange}
                            className="form-input"
                        >
                            <option value="">Select Automation</option>
                            <option value="Lead Generation">Lead Generation</option>
                            <option value="Social Media">Social Media Automation</option>
                            <option value="Email Marketing">Email Marketing Campaigns</option>
                            <option value="Customer Service">Customer Service Automation</option>
                            <option value="Content Creation">Content Creation & Distribution</option>
                            <option value="Data Processing">Data Processing & Analysis</option>
                            <option value="Scheduling">Scheduling & Calendar Management</option>
                            <option value="Workflow">Workflow Automation</option>
                            <option value="Custom">Custom Automation Solution</option>
                        </select>
                    </div>
                </div>

                <div className="form-row">
                    <div className="form-group">

                    <label>Website</label>
                    <input
                        type="text" // Changed from "url" to "text"
                        name="companyWebsite"
                        value={formData.companyWebsite}
                        onChange={handleChange}
                        className="form-input"
                        placeholder="brandbounce.io"
                    />
                    </div>
                </div>

                <div className="form-group full-width">
                    <label>Describe what you need</label>
                    <textarea
                        name="description"
                        value={formData.description}
                        onChange={handleChange}
                        className="form-textarea"
                        rows="4"
                        placeholder="Tell us more about your project requirements..."
                    />
                </div>

                <div className="form-group submit-group">
                    <button type="submit" className="cta-button" disabled={isLoading}>
                        {isLoading ? 'Submitting...' : 'Submit Request'}
                    </button>
                </div>
            </form>

            {/* Loading overlay */}
            {isLoading && (
                <div className="loading-overlay">
                    <div className="loader-container">
                        <div className="loader"></div>
                        <p>Submitting your request...</p>
                    </div>
                </div>
            )}

            {showPopup === "success" && (
                <div className="popup success">
                    <p>Thank you! We'll get back to you soon.</p>
                    <button onClick={() => setShowPopup(null)}>Close</button>
                </div>
            )}

            {showPopup === "error" && (
                <div className="popup error">
                    <p>There was an error. Please try again later.</p>
                    <button onClick={() => setShowPopup(null)}>Close</button>
                </div>
            )}

            <div className="social-media">
                <p>Follow us on:</p>
                <a href="https://www.facebook.com/people/Brand-Bounce/61559754806993/" target="_blank" rel="noreferrer">
                    <FaFacebook className="social-icon-contact" />
                </a>
                <a href="https://www.instagram.com/brandbounce.io/" target="_blank" rel="noreferrer">
                    <FaInstagram className="social-icon-contact" />
                </a>
            </div>

            <FaqSection />
        </div>
    );
};

export default ContactPage;